var endpointMap = {
	en: {
		"components.header": "translation-en.json",
		"components.navigation": "translation-en.json",
		"molecules.campaignActionBar": "translation-en.json",
		"molecules.cancelCampaignModal": "translation-en.json",
		"molecules.clearResultsModal": "translation-en.json",
		"molecules.conflictTable": "translation-en.json",
		"organisms.asinInclusionSection": "translation-en.json",
		"organisms.buybackSection": "translation-en.json",
		"organisms.campaignDetailsSection": "translation-en.json",
		"organisms.campaignTable": "translation-en.json",
		"organisms.cashbackSection": "translation-en.json",
		"organisms.dealGuardrailSection": "translation-en.json",
		"organisms.fundingAccountSection": "translation-en.json",
		"organisms.merchantGroupSection": "translation-en.json",
		"organisms.ncemiBankCardSection": "translation-en.json",
		"organisms.ncemiFundingSharesSection": "translation-en.json",
		"organisms.ncemiPriceLeadingSection": "translation-en.json",
		"organisms.pricingResultsTable": "translation-en.json",
		"organisms.schedulingSection": "translation-en.json",
		"pages.createCampaign": "translation-en.json",
		"pages.home": "translation-en.json",
		"pages.homepage": "translation-en.json",
		"pages.listCampaigns": "translation-en.json",
		"pages.modifyCampaign": "translation-en.json",
		"pages.mpcs": "translation-en.json",
		"pages.viewCampaign": "translation-en.json",
		"shared.campaignValidation": "translation-en.json",
		"shared.mpcsValidation": "translation-en.json"
	},
	"en-US": {
		"components.header": "translation-en.json",
		"components.navigation": "translation-en.json",
		"molecules.campaignActionBar": "translation-en.json",
		"molecules.cancelCampaignModal": "translation-en.json",
		"molecules.clearResultsModal": "translation-en.json",
		"molecules.conflictTable": "translation-en.json",
		"organisms.asinInclusionSection": "translation-en.json",
		"organisms.buybackSection": "translation-en.json",
		"organisms.campaignDetailsSection": "translation-en.json",
		"organisms.campaignTable": "translation-en.json",
		"organisms.cashbackSection": "translation-en.json",
		"organisms.dealGuardrailSection": "translation-en.json",
		"organisms.fundingAccountSection": "translation-en.json",
		"organisms.merchantGroupSection": "translation-en.json",
		"organisms.ncemiBankCardSection": "translation-en.json",
		"organisms.ncemiFundingSharesSection": "translation-en.json",
		"organisms.ncemiPriceLeadingSection": "translation-en.json",
		"organisms.pricingResultsTable": "translation-en.json",
		"organisms.schedulingSection": "translation-en.json",
		"pages.createCampaign": "translation-en.json",
		"pages.home": "translation-en.json",
		"pages.homepage": "translation-en.json",
		"pages.listCampaigns": "translation-en.json",
		"pages.modifyCampaign": "translation-en.json",
		"pages.mpcs": "translation-en.json",
		"pages.viewCampaign": "translation-en.json",
		"shared.campaignValidation": "translation-en.json",
		"shared.mpcsValidation": "translation-en.json"
	},
	und: {
		"components.header": "translation.json",
		"components.navigation": "translation.json",
		"molecules.campaignActionBar": "translation.json",
		"molecules.cancelCampaignModal": "translation.json",
		"molecules.clearResultsModal": "translation.json",
		"molecules.conflictTable": "translation.json",
		"organisms.asinInclusionSection": "translation.json",
		"organisms.auditInfoSection": "translation.json",
		"organisms.buybackSection": "translation.json",
		"organisms.campaignDetailsSection": "translation.json",
		"organisms.campaignStatusSection": "translation.json",
		"organisms.campaignTable": "translation.json",
		"organisms.cashbackSection": "translation.json",
		"organisms.dealGuardrailSection": "translation.json",
		"organisms.fundingAccountSection": "translation.json",
		"organisms.merchantGroupSection": "translation.json",
		"organisms.ncemiBankCardSection": "translation.json",
		"organisms.ncemiFundingSharesSection": "translation.json",
		"organisms.ncemiPriceLeadingSection": "translation.json",
		"organisms.pricingResultsTable": "translation.json",
		"organisms.schedulingSection": "translation.json",
		"organisms.suspendedProductsSection": "translation.json",
		"pages.createCampaign": "translation.json",
		"pages.home": "translation.json",
		"pages.homepage": "translation.json",
		"pages.listCampaigns": "translation.json",
		"pages.modifyCampaign": "translation.json",
		"pages.mpcs": "translation.json",
		"pages.viewCampaign": "translation.json",
		"shared.campaignValidation": "translation.json",
		"shared.mpcsValidation": "translation.json"
	}
};
var arbManifest = {
	endpointMap: endpointMap
};

export { arbManifest as default, endpointMap };
